var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<button type=\"button\" class=\"close channelSwitchDialog__close\"><span>Close</span></button>\n<h2 class=\"channelSwitchDialog__title\">Jump to channel</h2>\n<ul class=\"channelSwitchDialog__help\">\n    <li><strong>tab</strong>  or  <strong>↑ ↓</strong> to navigate</li>\n    <li><strong>↵</strong> to select</li>\n    <li><strong>esc</strong> to dismiss</li>\n    <li><i class=\"spin\"></i></li>\n</ul>\n<input class=\"channelSwitchDialog__input input\">\n<div class=\"channelSwitchDialog__channelLinks\"></div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/src/view/channel-switch-dialog.hbs
// module id = 3fPi
// module chunks = 1